var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useMemo } from "react";
import { Input as BaseInput, InputGroup as BaseInputGroup, Box, HStack, InputLeftAddon, InputRightAddon, Text, useTheme, } from "native-base";
import { isWeb } from "@madmedical/utils";
import Icon from "../../icons/Icon";
import Tooltip from "../../atoms/Tooltip";
const Input = forwardRef((_a, ref) => {
    var { size = "sm", leftAddon, rightAddon, suffix, tooltip, leftIconName, fullSize, InputLeftElement, InputRightElement, onChange } = _a, rest = __rest(_a, ["size", "leftAddon", "rightAddon", "suffix", "tooltip", "leftIconName", "fullSize", "InputLeftElement", "InputRightElement", "onChange"]);
    const { colors } = useTheme();
    const iconSizes = useMemo(() => ({
        sm: {
            px: 2,
        },
        md: {
            px: 3.5,
        },
    }), []);
    const renderIcon = useCallback((iconName) => (_jsx(Box, Object.assign({ pl: iconSizes[size].px }, { children: _jsx(Icon, { name: iconName, size: 14, fill: colors.gray[600] }) }))), [colors, iconSizes, size]);
    const renderInputRightElement = useCallback(() => {
        let elements = [];
        if (suffix) {
            const s = _jsx(Text, Object.assign({ color: "gray.600" }, { children: suffix }));
            elements.push(s);
        }
        if (tooltip) {
            const t = (_jsx(Tooltip, Object.assign({ label: tooltip }, { children: renderIcon("information") })));
            elements.push(t);
        }
        if (InputRightElement && !Array.isArray(InputRightElement)) {
            elements.push(InputRightElement);
        }
        else if (InputRightElement) {
            elements = [...elements, ...InputRightElement];
        }
        if (elements.length > 0) {
            return elements;
        }
        return [];
    }, [tooltip, suffix, renderIcon, InputRightElement]);
    const css = `
            input[type="number"][data-testid="input"]::-webkit-outer-spin-button,
            input[type="number"][data-testid="input"]::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
            input[type="number"][data-testid="input"] {
                -moz-appearance: textfield;
            }
            input[type="time"]::-webkit-calendar-picker-indicator{
                padding-right: 7px;
              }
        `;
    return (_jsxs(BaseInputGroup, Object.assign({ testID: "nativebase-input-group", maxWidth: "full", width: fullSize ? "full" : "auto" }, { children: [isWeb && _jsx("style", { children: css }), leftAddon && _jsx(InputLeftAddon, { children: leftAddon }), _jsx(BaseInput, Object.assign({ testID: "input", ref: ref !== null && ref !== void 0 ? ref : undefined, _input: {
                    pr: InputRightElement ? 0 : undefined,
                }, InputLeftElement: InputLeftElement !== null && InputLeftElement !== void 0 ? InputLeftElement : (leftIconName && renderIcon(leftIconName)), InputRightElement: _jsx(HStack, { children: renderInputRightElement().map((e, i) => (_jsx(Box, { children: e }, i))) }), size: size, height: size === "sm" ? 33 : 46, maxWidth: "full", width: "auto", flex: 1, onChangeText: onChange, overflowY: "hidden" }, rest)), rightAddon && _jsx(InputRightAddon, { children: rightAddon })] })));
});
Input.displayName = "Input";
export default Input;
